<script lang="ts" setup>
import { computed, ref, watch } from 'vue';
import { useClaimStore } from '../../store';
import { FwbTab, FwbTabs } from 'flowbite-vue'

import AgentFeedback from './AgentFeedback.vue';
import { computedAsync } from '@vueuse/core';
import adminAPI from '@/services/api';
import { AtSignIcon, CheckCheck, CircleCheckBig, Info, MessageCircleDashed, MessageCircleMore, MessageCircleQuestion, ReceiptEuro, ReceiptText, RectangleEllipsis, Signature, TimerOff, XIcon } from 'lucide-vue-next';
import LoaderButton from '@/components/ui/loaders/LoaderButton.vue';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { UserGroupIcon } from '@heroicons/vue/24/solid';
import { computePermissionForCurrentUser } from '@/utils/directives/v-permission';
import { InformationCircleIcon, ReceiptRefundIcon, CurrencyEuroIcon } from '@heroicons/vue/24/solid';
import { MousePointerClick } from 'lucide-vue-next'
import FormAdditionalLoss from '@/components/agent-feedback/FormAdditionalLoss.vue';
import { RetrieveClaimWithRelationsResponse } from '@/interfaces';

const claim = computed(() => useClaimStore().claim);

const loading = ref(true);
const claimAcquisitions = computedAsync(async() => {
  return adminAPI.listClaimAcquisitions(claim.value.id);
}, null, { lazy: false, evaluating: loading })

function generateEncodedUrl(email) {
  const encodedEmail = encodeURIComponent(email);
  const url = `https://account.postmarkapp.com/servers/6368441/streams/outbound/addresses/${encodedEmail}`;
  return url;
}

const stepIcon = (acquisition) => {
  if (acquisition.step === 'DECLINED') return XIcon;
  else if (acquisition.step === 'EXPIRED') return TimerOff;
  else if (acquisition.step === 'CONFIRM') return MessageCircleMore;
  else if (acquisition.step === 'EXPENSES') return CurrencyEuroIcon;
  else if (acquisition.step === 'SIGNATURE') return Signature;
  else if (acquisition.step === 'COMPLETE') return CircleCheckBig;
  else return RectangleEllipsis;
}

const tabs = ref(['automated', 'manual']);
const activeTab = ref(tabs.value[0]);
watch(loading, (data) => {
    console.log("claimAcquisitions.value?.families?.length", claimAcquisitions.value?.families?.length)
    if (claimAcquisitions.value) {
      tabs.value = ['automated', 'manual'];
    } else {
      console.log('iciiiiii...')
      tabs.value = ['manual'];
    }
    activeTab.value = tabs.value[0];
}, { immediate: true })
</script>
<template>
  <fwb-tabs v-model="activeTab" variant="underline" class="">
    <fwb-tab v-if="tabs.includes('automated')" name="automated" title="Flow automatisé">
      <div v-if="loading">
        <LoaderButton class="p-8 mx-auto" />
      </div>
      <div v-else class="h-full p-4 bg-slate-50">
        <div v-if="claimAcquisitions?.enterprise" class="p-6 my-8 bg-white border rounded-md">
          {{ claimAcquisitions.enterprise }}
        </div>
        <div v-for="acquisition of claimAcquisitions?.families" class="my-8 text-left">
          <div class="relative px-4 ">
            <div class="absolute inset-0 flex items-center" aria-hidden="true">
              <div class="w-full border-t border-gray-300" />
            </div>
            <div class="relative flex items-center justify-start">
              <span class="inline-flex items-center px-3 text-base font-semibold leading-6 text-gray-900 bg-slate-50">
                <div>
                    <span
                      :class="[
                        acquisition.step === 'EXPIRED' && 'text-gray-700 border-gray-100 ring-gray-50',
                        acquisition.step === 'CONFIRM' && 'text-amber-700 border-stone-100',
                        acquisition.step === 'EXPENSES' && 'text-blue-700 border-blue-100',
                        acquisition.step === 'SIGNATURE' && 'text-indigo-700 border-indigo-200 ring-indigo-100',
                        acquisition.step === 'COMPLETE' && 'text-green-700 border-green-100',
                        'flex shadow h-12 w-12 border-4 items-center bg-white justify-center rounded-full ring-2 ring-white',
                      ]"
                    >
                      <component
                        :is="stepIcon(acquisition)"
                        class="w-6 h-6"
                        aria-hidden="true"
                      />
                    </span>
                  </div>

                <!-- <XIcon v-if="acquisition.step === 'DECLINED'" class="mr-3" />
                <TimerOff v-if="acquisition.step === 'EXPIRED'" class="mr-3" />
                <RectangleEllipsis v-if="acquisition.step === 'CONFIRM'" class="mr-3" />
                <Signature v-if="acquisition.step === 'SIGNATURE'" class="p-5 mr-3 text-black bg-white border border-indigo-400 rounded-full ring-2 ring-indigo-200" />
                <CheckCheck v-if="acquisition.step === 'COMPLETE'" class="mr-3" /> -->
                <span v-if="acquisition.family.usersClaims.length === 1" class="ml-4">
                  {{ acquisition.family.usersClaims[0].user.firstName.split(" ").join("-") }} {{  acquisition.family.usersClaims[0].user.lastName.split(" ").join("-").toUpperCase() }}</span>
                <span v-else class="ml-4">Famille {{ acquisition.family.familyName }}</span>
              </span>
            </div>
          </div>

          <div class="mt-6">
            <div class="italic text-right">
              Envoyé le {{ new Date(acquisition.createdAt).toLocaleString() }}
            </div>
            <div class="p-6 bg-white border rounded-lg">
              <div class="block text-left">
                  <div class="flex items-center text-sm">
                    <span v-if="acquisition.step === 'EXPIRED'" class="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 font-medium text-gray-900 ring-1 ring-inset ring-gray-200">
                      <svg class="h-1.5 w-1.5 fill-gray-500" viewBox="0 0 6 6" aria-hidden="true">
                        <circle cx="3" cy="3" r="3" />
                      </svg>
                      <!-- <MessageCircleQuestion /> -->
                      Expiré
                    </span>
                    <span v-if="acquisition.step === 'DECLINED'" class="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 font-medium text-gray-900 ring-1 ring-inset ring-gray-200">
                      <svg class="h-1.5 w-1.5 fill-red-500" viewBox="0 0 6 6" aria-hidden="true">
                        <circle cx="3" cy="3" r="3" />
                      </svg>
                      <!-- <MessageCircleQuestion /> -->
                      Décliné
                    </span>
                    <span v-if="acquisition.step === 'CONFIRM'" class="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 font-medium text-gray-900 ring-1 ring-inset ring-gray-200">
                      <svg class="h-1.5 w-1.5 fill-yellow-500" viewBox="0 0 6 6" aria-hidden="true">
                        <circle cx="3" cy="3" r="3" />
                      </svg>
                      <!-- <MessageCircleQuestion /> -->
                      Attente confirmation incident
                    </span>
                    <span v-else-if="acquisition.step === 'EXPENSES'" class="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 font-medium text-gray-900 ring-1 ring-inset ring-gray-200">
                      <svg class="h-1.5 w-1.5 fill-blue-500" viewBox="0 0 6 6" aria-hidden="true">
                        <circle cx="3" cy="3" r="3" />
                      </svg>
                      <!-- <ReceiptText /> -->
                      En attente des dépenses
                    </span>
                    <span v-else-if="acquisition.step === 'SIGNATURE'" class="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 font-medium text-gray-900 ring-1 ring-inset ring-gray-200">
                      <svg class="h-1.5 w-1.5 fill-indigo-500" viewBox="0 0 6 6" aria-hidden="true">
                        <circle cx="3" cy="3" r="3" />
                      </svg>
                      <!-- <Signature/> -->
                      Attente Signature
                    </span>
                    <span v-else-if="acquisition.step === 'COMPLETE'" class="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 font-medium text-gray-900 ring-1 ring-inset ring-gray-200">
                      <svg class="h-1.5 w-1.5 fill-green-600" viewBox="0 0 6 6" aria-hidden="true">
                        <circle cx="3" cy="3" r="3" />
                      </svg>
                      <!-- <CheckCheck /> -->
                      Cession Signée
                    </span>
                    <span class="mx-2 text-sm" v-if="acquisition.stepUpdatedAt">·</span>
                    <span class="text-sm italic" v-if="acquisition.stepUpdatedAt">Depuis le {{ format(new Date(acquisition.stepUpdatedAt), "dd MMM yyyy", { locale: fr }) }}</span>
                  </div>
                  <!-- <span class="px-4"><Signature /></span> -->
                  <div class="block py-6 mt-4 space-y-2 leading-6">
                    <!-- <p>Cession « <a :href="`https://upclaim.app.box.com/file/${receivable.boxFileId}`" target="_blank" class="link">{{ receivable.boxFileName }}</a> »</p> -->
                    <div class="flex items-center text-sm">
                      <span class="inline-flex items-center font-semibold text-gray-900 ">
                        <UserGroupIcon class="w-5 h-5 mr-2 text-gray-500" />
                        Passager(s) :
                      </span>
                      <span class="ml-2">{{ acquisition.family.usersClaims.map(({ user }) => user.firstName.split(" ").join("-") + ' ' + user.lastName.split(" ").join("-").toUpperCase()).join(", ") }}</span>
                    </div>
                    <div class="flex items-center text-sm">
                      <span class="inline-flex items-center font-semibold text-gray-900 ">
                        <AtSignIcon class="w-5 h-5 mr-2 text-gray-500" />
                        Email :
                      </span>
                      <a v-if="computePermissionForCurrentUser('UPCLAIM_ADMIN')" class="ml-2 link" :href="generateEncodedUrl(acquisition.family.email)" target="_blank">{{ acquisition.family.email }}</a>
                      <a v-else class="ml-2 link" :href="`mailto:${acquisition.family.email}`">{{ acquisition.family.email }}</a>
                    </div>
                    <div class="flex items-center text-sm" v-if="acquisition.signature">
                      <span class="inline-flex items-center font-semibold text-gray-900 ">
                        <ReceiptEuro class="w-5 h-5 mr-2 text-gray-500" />
                        Montant total créance :
                      </span>
                      <span class="ml-2">{{ acquisition.signature.totalAmountEuro/100 }}€</span>
                    </div>
                    <div class="flex items-center mt-4 text-sm">
                      <span class="inline-flex items-center font-semibold text-gray-900 ">
                        <MousePointerClick class="w-5 h-5 mr-2 text-gray-500" />
                        Lien cliqué le :
                      </span>
                      <span v-if="acquisition.linkClickedAt" class="ml-2">{{ new Date(acquisition.linkClickedAt).toLocaleString() }}</span>
                      <span v-else class="ml-2 italic font-light">Pas encore cliqué</span>
                    </div>
                    <div v-if="acquisition.mayHaveEnterpriseExpenses" class="flex items-center mt-4 text-sm">
                      <span class="inline-flex items-center font-semibold text-gray-900 ">
                        <ReceiptRefundIcon class="w-5 h-5 mr-2 text-gray-500" />
                        Il a été indiqué qu'il y pu avoir des dépenses pour son entreprise
                      </span>
                    </div>
                  </div>
                  <div>
                    <!-- <div v-if="!receivable.signatureRequest?.createdAt">
                      <BaseInput
                        placeholder="Adresse email"
                        @update:model-value="(value) => {
                          signatureForm[receivable.boxFileId] = {
                            email: value,
                            fileId: receivable.boxFileId,
                            familyId: receivable.passengers[0].familyId,
                            signerFullName: signatureForm[receivable.boxFileId]?.signerFullName
                              || receivable.passengers[0].fullName
                          }
                        }"
                      />
                    </div> -->
                    
                    <div class="mt-2" v-if="acquisition.passengerNote">
                      <p class="text-base font-semibold text-gray-900">Note passager :</p>
                      <blockquote v-if="acquisition.passengerNote" class="px-2 mt-2 mb-3 text-sm font-medium prose whitespace-pre-line gray-700">
                        « {{ acquisition.passengerNote }} »
                      </blockquote>
                    </div>

                    <div v-if="acquisition.preExistingClaim" class="p-4 mt-8 mb-4 rounded-md bg-blue-50">
                      <div class="flex">
                        <div class="flex-shrink-0">
                          <InformationCircleIcon class="w-5 h-5 text-blue-400" aria-hidden="true" />
                        </div>
                        <div class="flex-1 ml-3 md:flex md:justify-between">
                          <p class="text-sm text-blue-700">Le passager avait déjà engagé une demande d'indemnisation.</p>
                        </div>
                      </div>
                    </div>
                    
                    <div class="mt-8" v-if="acquisition.expensesNote">
                      <p class="text-base font-semibold text-gray-900">Note sur les dépenses :</p>
                      <blockquote v-if="acquisition.expensesNote" class="px-2 mt-2 mb-3 text-sm font-medium prose whitespace-pre-line gray-700">
                        « {{ acquisition.expensesNote }} »
                      </blockquote>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </fwb-tab>
    <fwb-tab name="manual" title="Manuel">
      <AgentFeedback />
    </fwb-tab>
  </fwb-tabs>
</template>